import { DocsBlockBuilder } from "../../../../../../tools/docs-block-builder/SDKDocsBlockBuilder";
import { DocsBlockCategory } from "../../../../../enums/SDKDocsBlockCategory";
import { DocsBlockRichTextPropertyStyle } from "../../../../../enums/SDKDocsBlockRichTextPropertyStyle";
const b = new DocsBlockBuilder();
/**
 * 1. Block metadata
 */
const id = "io.supernova.block.title4";
const name = "Heading 4";
const icon = "https://cdn-assets.supernova.io/blocks/icons/v2/title-4.svg";
const descriptionShort = "Details in subsections";
const searchKeywords = ["title", "h4"];
const helpText = "Use for sub-divisions, elaborating on details within the subsections.";
const docsUrl = "https://learn.supernova.io/latest/documentation/types-of-blocks/text/heading-MUKlJ7dY";
/**
 * 2. Block properties
 */
const properties = {
    text: b.richTextProperty({
        id: "text",
        name: "Text",
        options: {
            placeholder: "Heading 4",
            richTextStyle: DocsBlockRichTextPropertyStyle.title4,
        },
    }),
};
/**
 * 3. Block variants
 */
const defaultVariant = b.defaultVariantUsingDefaultLayout({
    properties: [properties.text],
});
/**
 * 4. Block item
 */
const blockItem = b.singleVariantItem({
    properties: [properties.text],
    variant: defaultVariant,
});
/**
 * 5. Block definition
 */
const block = b.singleItemBlock({
    id,
    name,
    icon,
    category: DocsBlockCategory.text,
    description: descriptionShort,
    item: blockItem,
    searchKeywords,
    onboarding: b.onboarding({
        helpText,
        documentationLink: docsUrl,
    }),
});
/** 6. Block export */
export { block as Title4 };
